var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6L8.59 7.41Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationNext);
export default __webpack_public_path__ + "static/media/pagination-next.c0aa41d6c8de26d05f47be817ac71bea.svg";
export { ForwardRef as ReactComponent };